export function downloadJson(name: string, value: unknown): void {
  const blob = new Blob([JSON.stringify(value, null, 1)], { type: 'application/json' });
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = name;
  a.click();
  URL.revokeObjectURL(a.href);
}
